import React from 'react';

import {
  Stack,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

interface ShortRecordingNoteGuardTooltipProps {
  /** When true, the wrapped control is guarded — reveal the explanation on hover. */
  active: boolean;
  children: React.ReactNode;
}

/**
 * Wraps the Generate Note button. While `active` (cumulative audio under the
 * minimum), hovering surfaces why note generation is blocked.
 *
 * The trigger sits on a span, not the button: a native-disabled `<button>`
 * swallows hover/focus events, so a tooltip placed directly on it never opens.
 */
export const ShortRecordingNoteGuardTooltip = ({
  active,
  children,
}: ShortRecordingNoteGuardTooltipProps): React.ReactNode => {
  const { t } = useTranslation();

  if (!active) {
    return children;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex" tabIndex={0}>
          {children}
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <Stack gap={1} fullWidth={false}>
          <span className="font-semibold">
            {t('appointment.recordingTooShortTitle')}
          </span>
          <span>{t('appointment.recordingTooShortBody')}</span>
        </Stack>
      </TooltipContent>
    </Tooltip>
  );
};
